
import { AvatarDisplay } from "./AvatarDisplay";
import { UploadActions } from "./UploadActions";

interface DropZoneProps {
  avatar_url: string;
  full_name: string;
  isLoading: boolean;
  dragActive: boolean;
  onDragEnter: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDragOver: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  onDeleteAvatar: () => Promise<void>;
}

export function DropZone({
  avatar_url,
  full_name,
  isLoading,
  dragActive,
  onDragEnter,
  onDragLeave,
  onDragOver,
  onDrop,
  onImageUpload,
  onDeleteAvatar
}: DropZoneProps) {
  return (
    <div
      className={`flex items-center gap-4 p-3 rounded-lg border-2 border-dashed transition-colors ${
        dragActive ? "border-green-500 bg-white/5" : "border-white/20"
      }`}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <AvatarDisplay avatar_url={avatar_url} full_name={full_name} />
      
      <div className="flex-1">
        <p className="text-xs text-white/70 mb-2">
          Drag and drop or click to browse
        </p>
        <UploadActions
          avatar_url={avatar_url}
          isLoading={isLoading}
          onImageUpload={onImageUpload}
          onDeleteAvatar={onDeleteAvatar}
        />
      </div>
    </div>
  );
}
